<div class="change-password-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 margin-align">
    <h4 class="margin-header-align text-uppercase">{{'change-password.page-title' | translate}}</h4>
    <hr/>
  </div>

  <div [formGroup]="changePasswordForm" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 content-section">
    <div class="ui-g-12 field-rows">
      <label class="ui-g-5 field-label" for="password-input-email">{{'change-password.email' | translate}}</label>
      <input class="ui-input pInputText input-field-width" formControlName="email" id="password-input-email" pInputText
             readonly size="30" type="text">
    </div>

    <div class="ui-g-12 field-rows">
      <label for="password-input-old-value"
             class="ui-g-5 field-label">{{'change-password.old-password' | translate}}</label>
      <input id="password-input-old-value" type="password" size="30" pPassword [showPassword]="showPasswordOne"
             class="ui-input pInputText input-field-width" formControlName="oldPassword" [feedback]="false">
      <span class="show-password-container">
		            <i [ngClass]="showPasswordOne ? 'pi pi-eye-slash': 'pi pi-eye'"
                   (click)="showPasswordOne = !showPasswordOne"></i>
		        </span>
    </div>

    <div class="ui-g-12 field-rows">
      <label for="password-input-new-value"
             class="ui-g-5 field-label">{{'change-password.new-password' | translate}}</label>
      <input id="password-input-new-value" type="password" size="30" pPassword [showPassword]="showPasswordTwo"
             class="ui-input pInputText input-field-width" formControlName="newPassword" [feedback]="false">
      <span class="show-password-container">
		            <i [ngClass]="showPasswordTwo ? 'pi pi-eye-slash': 'pi pi-eye'"
                   (click)="showPasswordTwo = !showPasswordTwo"></i>
		        </span>
    </div>

    <div class="ui-g-12 field-rows">
      <label for="password-input-repeat-value"
             class="ui-g-5 field-label">{{'change-password.repeat-password' | translate}}</label>
      <input id="password-input-repeat-value" type="password" size="30" pPassword [showPassword]="showPasswordThree"
             class="ui-input pInputText input-field-width" formControlName="repeatPassword" [feedback]="false">
      <span class="show-password-container">
		            <i [ngClass]="showPasswordThree ? 'pi pi-eye-slash': 'pi pi-eye'"
                   (click)="showPasswordThree = !showPasswordThree"></i>
		        </span>
    </div>

    <div class="ui-g-12 field-rows">
      <div *ngIf="errorMessage" class="ui-g-offset-5 error-message">{{errorMessage}}</div>
    </div>

    <div class="ui-g-5 ui-g-offset-5 button-rows">
      <button pButton type="button" class="submit-button"
              id="password-btn-submit"
              label="{{'change-password.submit-button-label' | translate}}" (click)="saveFormData()"
              [disabled]="disableSubmitButton"></button>

      <button pButton type="button" class="cancel-button"
              id="password-btn-cancel"
              label="{{'change-password.cancel-button-label' | translate}}" (click)="resetForm()"
              [disabled]="changePasswordForm.untouched"></button>
    </div>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
